import Vue from "vue";

export default {
  storePartnerList(state, partners) {
    state.partners = partners;
  },
  storePartner(state, partner) {
    state.partner = partner;
  },
  storeUpdatedPartner(state, updatedPartner) {
    state.partner = updatedPartner;
  },
  storeCreatedPartner(state, createdPartner) {
    state.partners << createdPartner
  },
  storeCommonData(state, data) {
    Vue.set(state, 'commonData', data);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/partners/mutations.js